import { useEffect, useState } from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { useDispatch } from 'react-redux';
import { Box, Button, Card, Tab, Tabs } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import WhatsappMessageList from './WhatsappMessageList';

const NotificationLog = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'notificationLog'
        });
    }, []);
    const [tabValue, setTabValue] = useState('0');
        
    // Handle tab change and update URL
        const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
  return (
    <>
        <PageHeaderLayout headerTitle={'Notification Log'} >
            {/* <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<ArrowBack/>}>
                Back
            </Button> */}
        </PageHeaderLayout>
        {/* <AbandonedCartList/> */}
        {/* <AddEditNotification/> */}
        {/* <NotificationDashboard/> */}
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
    
                <Tab value="0" label="Whatsapp" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                {/* <Tab value="1" label="Campaign List" sx={{ minHeight: '40px', textTransform: 'capitalize' }} /> */}
                {/* <Tab value="three" label="Item Three" /> */}
                </Tabs>
            </Box>
        </Card>
        {tabValue === '0' && <WhatsappMessageList setTabValue={setTabValue} />}
        {/* {tabValue === '1' && <CampaignList />} */}
    </>
  )
}

export default NotificationLog